module.exports = __webpack_public_path__ + "8795dd4f64f8f018386f4b1c9492579c.png";